// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2ditL","info":"Note_info__FHyAF","note":"Note_note__3fy9k","actions":"Note_actions__2Mbu-"};